import { mittweidaFields } from 'mittweida/inquiry/fields';
import { fieldValidators } from 'modules/Inquiry/inquiryFieldValidation/customValidations';

export const roleSectionValidationMap = {
  [mittweidaFields.financingNeedPage.roleSection.projectFinancingRole]: fieldValidators
    .string()
    .required(),
};
